export default "__VITE_ASSET__mXfYf2Z2__"